import { render, staticRenderFns } from "./Shopcart.vue?vue&type=template&id=12ef6d36&scoped=true"
import script from "./Shopcart.vue?vue&type=script&lang=js"
export * from "./Shopcart.vue?vue&type=script&lang=js"
import style0 from "./Shopcart.vue?vue&type=style&index=0&id=12ef6d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef6d36",
  null
  
)

export default component.exports